import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  let user = localStorage.getItem("userToken");
  let exchangePoint = true;
  return (
    <Route
      {...rest}
      render={(props) =>
        //if there is a token and the user is active, allow in
        user && exchangePoint ? <Component {...props} /> : <Redirect to="/telefono" />
      }
    />
  );
};

export default PrivateRoute;
